var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Media Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "youtube",
    d: "M17.7002 9.07505C17.5502 8.55005 17.1753 8.17505 16.6503 8.02505C15.7503 7.80005 11.9252 7.80005 11.9252 7.80005C11.9252 7.80005 8.17525 7.80005 7.20025 8.02505C6.67525 8.17505 6.30024 8.55005 6.15024 9.07505C6.00024 10.05 6.00024 12 6.00024 12C6.00024 12 6.00025 13.95 6.22525 14.925C6.37525 15.45 6.75024 15.825 7.27524 15.975C8.17524 16.2 12.0002 16.2 12.0002 16.2C12.0002 16.2 15.7502 16.2 16.7252 15.975C17.2502 15.825 17.6253 15.45 17.7753 14.925C18.0003 13.95 18.0002 12 18.0002 12C18.0002 12 18.0002 10.05 17.7002 9.07505ZM10.8002 13.8V10.2L13.9502 12L10.8002 13.8Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.8e31cc345addbc06e014d772a2eb4d23.svg";
export { ForwardRef as ReactComponent };